<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <material-card :title="title">
      {{ text }}
      <template v-slot:actions>
        <v-spacer />
        <v-btn
          color="primary"
          :loading="loading"
          @click="yes"
        >
          Yes
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          No
        </v-btn>
      </template>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    data () {
      return {
        dialog: false,
        loading: false,
        title: null,
        text: null
      }
    },
    methods: {
      open (title, text, onYes) {
        this.title = title
        this.text = text
        this.dialog = true
      },
      yes () {
        this.loading = true
        this.$emit('yes', () => {
          this.loading = false
          this.dialog = false
        })
      }
    }
  }
</script>
